import React from "react"

import { ProductPageAddToProject } from "./ProductPageAddToProject"
import { ProductPageConfigureButton } from "./ProductPageConfigureButton"
import { ProductPageDimensionButton } from "./ProductPageDimensionButton"
import { ProductPageDownloadButton } from "./ProductPageDownloadButton"

export const ProductPageActions = React.memo(() => (
  <div className="product-page__actions">
    <ProductPageConfigureButton />
    <ProductPageDimensionButton />
    <ProductPageDownloadButton />
    <ProductPageAddToProject />
  </div>
))
